import { first, mergeMap, switchMap, toArray } from 'rxjs/operators';
import { TranslationDataStore } from './translation-data-store';
import { from } from 'rxjs';

export async function fetchLocale(locale: string) {
    const { lang, message } = await TranslationDataStore.getInstance()
        .fetchOne(locale, true)
        .pipe(first())
        .toPromise();

    return { [lang]: { message } };
}

export function fetchAllLocales(availableLocales: string[] = []) {
    return TranslationDataStore.getInstance()
        .getAllAvailableLanguages(availableLocales).pipe(
            switchMap(from),
            mergeMap(key => TranslationDataStore.getInstance().fetchOne(key)),
            toArray(),
        )
}
